import styled from "styled-components";
import { theme } from "../../../../../../shared-components/deprecated-styled-components/toyota/theme/toyotaTheme";

export const Wrapper = styled.div`
    position: relative;
    max-width: 100%;
`;

export const Popup = styled.div`
    position: absolute;
    inset-inline: 0;
    min-width: 256px;
    background: ${theme.colors.primaryWhite};
    border-radius: 4px;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
    z-index: ${theme.zIndex.popover};

    @supports not (inset-inline: 0) {
        left: 0;
        right: 0;
    }
`;

export const SortIconWrapper = styled.div`
    @supports not (gap: 0) {
        margin-right: ${theme.space[3] / 2}px;

        html[dir="rtl"] & {
            margin-left: ${theme.space[3] / 2}px;
            margin-right: 0;
        }
    }
`;
